import React, { useState } from "react";
import ConnectMT5 from "../components/ConnectMT5";
import DeltaConnect from "../components/DeltaConnect";
import { useEntitlements } from "../context/EntitlementsContext";

// Always-accessible broker connection screen (works in demo mode).
const ConnectBroker = () => {
  const { refresh } = useEntitlements();
  const [rangeDays, setRangeDays] = useState(0);
  return (
    <div className="max-w-[1180px] mx-auto px-8 py-8" data-testid="connect-broker-page">
      <div className="mb-6">
        <span className="text-[11px] tracking-[0.28em] text-[color:var(--ws-muted)] uppercase">Connect · Verify · Unlock</span>
        <h1 className="ws-heading text-3xl font-bold mt-2">Connect your broker</h1>
        <p className="text-[color:var(--ws-muted)] text-sm mt-1">
          Connect a verified <span className="text-white font-semibold">XM</span> or{" "}
          <span className="ws-elefin-glow font-semibold">Elefin</span> account to unlock the full platform — free.
        </p>
      </div>
      <ConnectMT5 onSynced={refresh} rangeDays={rangeDays} setRangeDays={setRangeDays} />
      <DeltaConnect />
    </div>
  );
};

export default ConnectBroker;
